import { clsx } from "@trydig/ui";
import type { ChangeEvent } from "react";
import styles from "./Counter.module.css";

// TODO: Consider unifying with apps/rauma-garn/src/components/atoms/CartCounter/index.tsx
export const Counter = ({
	max,
	value = 0,
	min = 0,
	disabled = false,
	onChange,
	increment,
	decrement,
	stock,
	large,
}: {
	max?: number;
	min?: number;
	value?: number;
	disabled?: boolean;
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
	increment?: () => void;
	decrement?: () => void;
	stock?: number;
	large?: boolean;
}) => {
	return (
		<div
			className={`${styles["yarn-quantity"]} ${
				disabled ? styles["yarn-quantity-disabled"] : ""
			} ${large ? styles["yarn-quantity-large"] : ""}`}
		>
			<div className={styles["quantity-input"]}>
				<label htmlFor="quantity" style={{ display: "none" }}>
					Antall
				</label>
				<button
					disabled={disabled || value <= min}
					className={clsx(styles["quantity-button"], value === 0 && styles["disabled-button"])}
					onClick={decrement}
				>
					-
				</button>
				<span>
					<input id="quantity" value={value} onChange={onChange} readOnly={true} />
					{max && (
						<p>
							<span>/</span>
							{max}
						</p>
					)}
				</span>
				<button
					className={clsx(
						styles["quantity-button"],
						stock && value > stock && styles["disabled-button"],
					)}
					onClick={increment}
				>
					+
				</button>
			</div>
		</div>
	);
};
